import message from "@/utils/globalMessage";
import React from 'react';
import { Dropdown } from "antd";
import {
  MoreOutlined,
  FolderOpenOutlined,
  FileOutlined,
  AppstoreOutlined,
  EditOutlined,
  TagOutlined,
  ReloadOutlined,
  DownloadOutlined,
  DeleteOutlined,
  ScissorOutlined,
  ChromeOutlined,
  CopyOutlined,
  HighlightOutlined,
  ShareAltOutlined,
  StarOutlined,
} from '@ant-design/icons';
import { api } from '@/redux/api';
import { canOpenInApp, copyLink, FILE_MANAGEMENT_POPUP_Z_INDEX, getSafeUrl, handleDownload, openInApp, openInBrowser } from './utils';


export const DropdownMenu = ({
  record,
  currentFileRef,
  openEditModal,
  setIsFileOpen,
  setCurrentOpenFile,
  reload,
  setCurrentTreeKeyWithClearSearch,
  onRequestDeleteConfirm,
  openEditTagModal,
  openRenameModal,
  openMoveToModal,
  onClipboard,
  canWrite,
  canFullAccess,
  userId,
  isFavorited,
  toggleFavorite,
  trigger = 'click',
  children
}) => {

  const isFolder = record.isFolder;
  const isOwner = record.createdby === userId;
  // 虚拟节点只读：保留 Open / Download / Copy Link / Favorites，写操作隐藏。
  const isVirtual = !!record.isVirtual;
  // 合同托管目录：结构由合同便签流维护，不允许改名/移动/删除/剪切。
  const isManagedFolder = !!record.isFolder && !!record.is_system_managed;
  const canDeleteRecord = !isVirtual && !isManagedFolder && (canFullAccess || isOwner);

  // const handleDownload = async (record) => {

  //   const { image: downloadUrl, name } = record;

  //   const generate_url = await api.generate_url(getSafeUrl(downloadUrl), false).then(
  //     response => {
  //       const url = response.data.url;
  //       return url
  //     })

  //   const link = document.createElement('a');
  //   link.href = generate_url;
  //   link.setAttribute('download', name);
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link)
  // }


  const menuItems = [
    {
      key: 'group1',
      type: 'group',
      children: isFolder ? [{ key: '1', icon: <FolderOpenOutlined />, label: 'Open Folder', onClick: () => setCurrentTreeKeyWithClearSearch(record) }] :
        [
          {
            key: '2', icon: <FileOutlined />, label: 'Open', onClick() {
              setIsFileOpen(true)
              setCurrentOpenFile(record)
            }
          },
          ...(canOpenInApp(record) ? [{
            key: '3', icon: <ChromeOutlined />, label: 'Open in Browser', onClick: async () => {
              openInBrowser(record)
            }
          }] : []),
          ...(canOpenInApp(record) ? [{
            key: '4', icon: <AppstoreOutlined />, label: 'Open in App', onClick: async () => {
              openInApp(record)
            }
          }] : [])
        ],
    },
    { type: 'divider' },
    {
      key: 'group2',
      type: 'group',
      children: [
        ...(canWrite && !isVirtual && !isManagedFolder ? [{
          key: '5', icon: <EditOutlined />, label: 'Edit', onClick: () => {
            openEditModal(record)
          }
        }] : []),
        ...(canWrite && !isVirtual && !isManagedFolder ? [{
          key: '6', icon: <HighlightOutlined />, label: 'Rename', onClick() {
            openRenameModal(record)
          }
        }] : []),
        ...(!isFolder && canWrite && !isVirtual ? [{
          key: '7', icon: <TagOutlined />, label: 'Edit Tags', onClick() {
            openEditTagModal(record)
          }
        }] : [])
        // { key: '7', icon: <CategoryOutlined />, label: 'Edit Category' },
        // { key: '8', icon: <FileTextOutlined />, label: 'Edit Description' },
      ],
    },
    { type: 'divider' },
    {
      key: 'group3',
      type: 'group',
      children: [
        ...(isFolder ? [] : [{
          key: '10', icon: <DownloadOutlined />, label: 'Download', onClick() {
            handleDownload(record)
          }
        }]),
        { key: '9', icon: <ReloadOutlined />, label: 'Refresh', onClick: reload },
        ...(canDeleteRecord ? [{
          key: '11', icon: <DeleteOutlined />, label: 'Delete', onClick() {
            if (typeof onRequestDeleteConfirm === 'function') {
              onRequestDeleteConfirm(record);
            }
          }
        }] : []),
      ],
    },
    { type: 'divider' },
    {
      key: 'group4',
      type: 'group',
      children: [
        // { key: '12', icon: <CopyOutlined />, label: 'Copy To' },
        ...(isFolder ? [] : [{
          key: '14', icon: <ShareAltOutlined />, label: 'Copy Link', onClick() {
            copyLink(record)
          }
        }]),
        ...(canWrite && !isVirtual && !isManagedFolder && typeof onClipboard === 'function' ? [{
          key: '16', icon: <CopyOutlined />, label: 'Copy', onClick: () => onClipboard([record], 'copy')
        }, {
          key: '17', icon: <ScissorOutlined />, label: 'Cut', onClick: () => onClipboard([record], 'cut')
        }] : []),
        ...(canWrite && !isVirtual && !isManagedFolder ? [{
          key: '13', icon: <ScissorOutlined />, label: 'Move To', onClick() {
            openMoveToModal(record)
          }
        }] : []),
      ],
    },
    { type: 'divider' },
    {
      key: 'group5',
      type: 'group',
      children: [
        {
          key: '15', icon: <StarOutlined />, label: isFavorited ? 'Remove from Favorites' : 'Add to Favorites',
          onClick() { toggleFavorite(record.id); }
        },
      ],
    },
  ];

  return (
    <>
      <Dropdown
        menu={{ items: menuItems }}
        trigger={[trigger]}
        overlayClassName="file-context-menu-overlay"
        overlayStyle={{ minWidth: 180, zIndex: FILE_MANAGEMENT_POPUP_Z_INDEX }}
      >
        {children ? children : <MoreOutlined style={{ cursor: 'pointer', fontSize: 16, padding: 4, borderRadius: 4, transition: 'background 0.15s ease' }} />}
      </Dropdown>
    </>
  );
};
